import { render, staticRenderFns } from "./SFXEditAssembly.vue?vue&type=template&id=2482aebb&scoped=true&"
import script from "./SFXEditAssembly.vue?vue&type=script&lang=js&"
export * from "./SFXEditAssembly.vue?vue&type=script&lang=js&"
import style0 from "./SFXEditAssembly.vue?vue&type=style&index=0&id=2482aebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2482aebb",
  null
  
)

export default component.exports